module.exports = __webpack_public_path__ + "img/inu_thumbnail.07428d38.jpg";